export default "/images/vendor/flag-icons/flags/4x3/az.svg?aae9c7ff43e36d202a0005fe43839364";